module.exports = __webpack_public_path__ + "img/star-l-00b7ff.138ce86a.svg";